import { getAdminSession } from '../../../api/adminApi';
import { showLoginScreen } from './login';
import { showDashboardScreen } from './dashboard';
// Entry point for the `admin` block (#page=admin). Owns the root elements and
// the navigation context every screen module receives; each screen lives in
// its own file — see docs/impl/admin-panel.md.
export function renderAdmin(_block) {
    const section = document.createElement('section');
    section.className = 'admin';
    const screen = document.createElement('div');
    screen.className = 'admin__screen';
    section.appendChild(screen);
    const ctx = {
        section,
        screen,
        showLogin: () => showLoginScreen(ctx),
        showDashboard: () => showDashboardScreen(ctx),
    };
    getAdminSession()
        .then((session) => {
        if (session.authorized) {
            ctx.showDashboard();
        }
        else {
            ctx.showLogin();
        }
    })
        .catch(() => ctx.showLogin());
    return section;
}
